import AdminUserRoles from "./AdminUserRoles";
import { DEFAULT_USER_ROLE_BY_SCOPE } from "../constants/roles";

import type {
  AdminUserContructorParams,
  AdminUserToAPI,
} from "../types/adminUser";

class AdminUser {
  adminUserRoles: AdminUserRoles;

  roleList: string[];

  rolesString: string;

  rolesCount: number;

  isAdminOrOwner: boolean;

  isOwner: boolean;

  lastName: string;

  firstName: string;

  status: string;

  company: string | null;

  email: string;

  password?: string;

  avatarUrl: string;

  uuid: string;

  constructor(user: AdminUserContructorParams) {
    this.adminUserRoles =
      user?.adminUserRoles ??
      new AdminUserRoles(user?.userRoles ?? DEFAULT_USER_ROLE_BY_SCOPE);
    this.roleList = this.adminUserRoles.roleList;
    this.rolesString = this.adminUserRoles.rolesString;
    this.rolesCount = this.adminUserRoles.roleCount;
    this.isAdminOrOwner = this.adminUserRoles.isAdminOrOwner;
    this.isOwner = this.adminUserRoles.isOwner;
    this.lastName = user.lastName;
    this.firstName = user.firstName;
    this.status = user.status;
    this.company = user.company;
    this.email = user.email;
    this.password = user?.password;
    this.avatarUrl = user.avatarUrl;
    this.uuid = user.uuid;
  }

  static type = "AdminUser";

  get isEnabled(): boolean {
    return this.status === "enabled";
  }

  setIsEnabled(boolean: boolean): AdminUser {
    this.status = boolean ? "enabled" : "disabled";

    return this;
  }

  toAPI(): AdminUserToAPI {
    return {
      last_name: this.lastName,
      first_name: this.firstName,
      status: this.status,
      company: this.company,
      email: this.email,
      password: this.password,
      avatar: this.avatarUrl,
      uuid: this.uuid,
    };
  }
}

export default AdminUser;
